import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <div className="privacy-content">
          <section>
            <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
          </section>

          <section>
            <h2>1. Information We Collect</h2>
            <p>
              FeatureMap collects information necessary to provide our service, including:
            </p>
            <ul>
              <li><strong>Account Information:</strong> Email address, password (encrypted), and profile information you provide.</li>
              <li><strong>Usage Data:</strong> Information about how you use the service, including features accessed, actions taken, and timestamps.</li>
              <li><strong>Feature Data:</strong> Content you create, including feature names, descriptions, tags, and related information.</li>
              <li><strong>Cookies:</strong> We use cookies to track usage, maintain your session, and provide authentication services.</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our services</li>
              <li>Authenticate users and manage access to feature groups</li>
              <li>Track usage patterns to improve user experience</li>
              <li>Send important service-related communications</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>3. Cookies and Tracking</h2>
            <p>
              We use cookies to:
            </p>
            <ul>
              <li>Maintain your authentication session</li>
              <li>Track usage patterns and analytics</li>
              <li>Remember your preferences</li>
            </ul>
            <p>
              By using FeatureMap, you consent to our use of cookies. You can decline cookies, 
              but this will prevent you from logging in and using the service.
            </p>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your 
              personal information against unauthorized access, alteration, disclosure, or destruction. 
              This includes encryption, secure authentication, and access controls.
            </p>
          </section>

          <section>
            <h2>5. Data Sharing</h2>
            <p>
              We do not sell your personal information. We may share your information only:
            </p>
            <ul>
              <li>With other members of your feature groups (as determined by group owners)</li>
              <li>When required by law or to protect our rights</li>
              <li>With service providers who assist in operating our platform (under strict confidentiality agreements)</li>
            </ul>
          </section>

          <section>
            <h2>6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your account and data</li>
              <li>Export your data</li>
              <li>Withdraw consent for cookie usage (though this will limit service functionality)</li>
            </ul>
          </section>

          <section>
            <h2>7. Data Retention</h2>
            <p>
              We retain your information for as long as your account is active or as needed to 
              provide services. When you delete your account, we will delete or anonymize your 
              personal information, except where we are required to retain it for legal purposes.
            </p>
          </section>

          <section>
            <h2>8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any 
              material changes by posting the new policy on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section>
            <h2>9. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact your feature group 
              administrator or reach out through your account settings.
            </p>
          </section>

          <div className="privacy-footer">
            <Link to="/" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;





